module.exports = __webpack_public_path__ + "media/images/form-status-new-5235688e.gif";